var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 63,
    viewBox: "0 0 55 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_390_18908)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.5191 44.263L49.5077 38.6568C42.6574 42.6119 35.8094 46.5669 28.9591 50.5243C28.9477 44.5223 28.9477 38.5203 28.9272 32.5184C37.5811 27.4921 46.2395 22.4681 54.8956 17.4441C54.8979 19.5183 54.9024 21.5925 54.9047 23.6667C48.0544 27.6217 41.2064 31.5745 34.3538 35.5319L34.3652 41.1404C41.2155 37.1853 48.0635 33.2302 54.9115 29.2752C54.9229 35.3158 54.9343 41.3564 54.9434 47.3971C46.2872 52.3961 37.6288 57.3905 28.9727 62.3895L28.9773 56.126C35.8185 52.1709 42.6688 48.2272 49.5122 44.2699L49.5191 44.263Z",
    fill: "#CAC0FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 47.3836L5.41746 50.5267C5.43566 42.6507 5.44476 34.7746 5.4584 26.8964L10.3141 29.7006C10.305 37.5812 10.2868 45.464 10.2732 53.3446C12.079 54.3953 13.8848 55.4438 15.6906 56.49C15.7043 48.6026 15.7179 40.7152 15.7316 32.8255L20.5873 35.6298C20.5782 43.4944 20.6805 51.4569 20.5441 59.3102L25.9661 62.451C25.9865 52.469 26.0025 42.4846 26.0184 32.5026C17.3623 27.5082 8.70615 22.5114 0.0500353 17.5125C0.034115 27.4718 0.034115 37.4265 0 47.3836Z",
    fill: "#8C71F6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.7621 9.01099C40.9608 10.0572 39.1595 11.1011 37.3605 12.1473L42.4823 15.1199L27.399 23.8783L12.3156 15.1199C17.3441 12.1996 22.3727 9.28391 27.399 6.36366L32.5208 9.33622C34.322 8.2923 36.1233 7.24611 37.9223 6.19991C34.479 4.20077 31.0333 2.20163 27.59 0.202493L27.5195 0.161555V0.0228204L27.399 0.0910504L27.2397 -0.00219727V0.184298L27.1692 0.225236L27.0715 0.282095C18.5472 5.23105 10.0276 10.1754 1.50793 15.1199C10.1413 20.1348 18.7815 25.1428 27.4149 30.1577C36.0414 25.1474 44.6634 20.137 53.2854 15.1199C49.7761 13.0843 46.2691 11.0465 42.7621 9.01099Z",
    fill: "#693EE0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_390_18908"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54.9479,
    height: 62.41,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.e8d739b0b1306f79999e154879cd12c2.svg";
export { ForwardRef as ReactComponent };